/**
 * État réel de la mesure d'audience, déclaré par le Worker dans le <head>.
 *
 * La page Confidentialité s'y adapte : elle ne doit jamais décrire une mesure qui n'existe pas,
 * ni taire celle qui existe. « none » tant qu'aucun jeton n'est configuré.
 */
export type AnalyticsState = 'none' | 'cloudflare';

export function analyticsState(): AnalyticsState {
  if (typeof document === 'undefined') return 'none';
  // Balise posée par notre Worker (jeton configuré)…
  const meta = document.querySelector<HTMLMetaElement>('meta[name="ermont-live:analytics"]');
  if (meta?.content === 'cloudflare') return 'cloudflare';
  // …ou injectée par Cloudflare lui-même sur un domaine proxifié : on la cherche dans la page.
  const injected = document.querySelector('script[src*="cloudflareinsights.com"], script[data-cf-beacon]');
  return injected === null ? 'none' : 'cloudflare';
}
